import { slotExport, inventory } from "@/Api/EquipmentTaskController";
import { getViews,updRemark } from "@/Api/StockSlotController";
import { CommonTable } from "@/Common/Table/EditTable";
import { PrintFooter } from "@/Common/Table/PrintFooter";
import { numProps, strProps, strSorter } from "@/Common/Table/column";
import { TableInnerButton } from "@/Common/Table/getTableAction";
import { renderCopyable } from "@/Common/Table/renderCopyable";
import { ColumnType } from "@/Common/Table/type";
import { toYMD, toYMDHMS } from "@/Common/date";
import { getStockFlagName } from "@/Models/Enums/StockFlag";
import { StockSlotSplitPageProps, useQueryPageChange } from "@/Models/Other/BaseSplitPageProps";
import { PaginationData } from "@/Models/Other/PaginationData";
import { ViewStockSlot } from "@/Models/Views/ViewStockSlot";
import { Button, Popconfirm, Upload, UploadProps, message,Form,Input } from "antd";
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SearchComponent } from "./SearchComponent";
import EditQuantityForm from "./EditQuantityForm";
import { CheckInventory } from "./CheckInventory";
import { ViewCheckInventory } from "@/Models/Views/ViewInventory";
import { MyModal } from "@/Common/Form/MyModal";
import {
  UploadOutlined,
  ArrowDownOutlined
} from "@ant-design/icons";
import axios from "axios";
export default Index;

function getColumns(onShowEditQuantity: (r: ViewStockSlot) => void): ColumnType<ViewStockSlot>[] {
  return [
    strProps("warehouseName", "仓库", 100, true, true),
    strProps("lanewayName", "巷道", 100, true, true),
    strProps("goodsTypeName", "类型", 100, true, true),
    strProps("goodsCode", "物品编码", 100, true, true),
    strProps("goodsName", "物品名称", 300, true, true, renderCopyable),
    strProps("standard", "规格", 220, true, true),
    strProps("batchNo", "批次", 120, true, true),
    // numProps("quantity", "数量", 80, true),
    strProps("unit", "单位", 60, false, false),
    strProps("stockCode", "托盘条码", 120, true, true),
    //strProps("slotCode", "储位编码", 120, true, true),
    { title: "储位编码", dataIndex: "slotCode", width: 114, render: (_, r) => <SlotCodeActionComponent data={r} /> },
    numProps("quantity", "数量", 80, true, (s, r) => <TableInnerButton type="link" onClick={() => onShowEditQuantity(r)}>{s}</TableInnerButton>),
    numProps("inventoryTime", "盘点时间", 160, true, toYMDHMS),
    strProps("supplierName", "供应商", 120, true, true), strProps("customerName", "客户", 120, true, true),
    strProps("goodsStatusName", "品质状态", 120, true, true),
    numProps("productionDate", "生产日期", 120, true, toYMD, true),
    strProps("contractNumber", "合同号", 160, true, true),
        {
      title: "备注",
      dataIndex: "remark",
      width: 150,
      sorter: false,
      render: (_, r) => <UpdateImportBill record={r} />,
    },
    strProps("orderNo", "入库流水号", 160, true, true),
    numProps("time", "入库时间", 160, true, toYMDHMS),
    { title: "状态", dataIndex: "flag", width: 80, sorter: strSorter("flag"), render: getStockFlagName }
  ];
}

export function UpdateImportBill({ record }: { record: ViewStockSlot }) {
  const [edit, setEdit] = useState<ViewStockSlot>();
  const onEdit = useCallback(() => setEdit(record), [record]);
  const onCancel = useCallback(() => setEdit(undefined), []);

  return (
    <Fragment>
      <TableInnerButton type="link" onClick={onEdit}>
        {record.remark
          ? record.remark.length > 8
            ? record.remark.slice(0, 8) + "......"
            : record.remark
          : "备注修改"}
      </TableInnerButton>
      {edit && <UpdateImportBillRemark record={edit} onCancel={onCancel} />}
    </Fragment>
  );
}

function UpdateImportBillRemark({
  record,
  onCancel,
}: {
  record: ViewStockSlot;
  onCancel: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const onOk = useCallback(async () => {
    setLoading(true);
    try {
      await form.validateFields().then((f) => {
        const remark = form.getFieldValue("remark");
        if (!remark) {
          message.error("请填写备注！");
          return;
        }
        updRemark(record.id, remark).then((r: number) => {
          if (r > 0) {
            message.success("操作成功！");
            record.remark = remark;
            onCancel();
          } else {
            message.error("操作失败！");
          }
        });
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [form, onCancel, record]);

  return (
    <MyModal
      name="备注"
      confirmLoading={loading}
      width={520}
      onCancel={onCancel}
      onOk={onOk}
    >
      <Form form={form} initialValues={record}>
        <Form.Item name="remark" label="备 注">
          <Input.TextArea style={{ height: "150px" }} maxLength={150} />
        </Form.Item>
      </Form>
    </MyModal>
  );
}

function SlotCodeActionComponent({ data }: { data: ViewStockSlot }) {
  const [loading, setLoading] = useState(false);
  const onConfirm = useCallback(async () => {
    try {
      setLoading(true);
      await slotExport(data.id).then(s => {
        if (s && s.toString().indexOf("成功") === -1) {
          message.error(s);
        } else {
          message.success('操作成功！');
        }
      });
    } catch (error) {
      message.info(JSON.stringify(error));
    }
    finally {
      setLoading(false);
    }
  }, [data.slotId])
  if (data && data.slotCode && data.slotCode.length === 8) {
    return (<Popconfirm disabled={loading} title={`您确定要对储位[${data.slotCode}]进行盘点出库作业吗?`} onConfirm={onConfirm}>
      <TableInnerButton loading={loading} disabled={loading} type="link">{data.slotCode}</TableInnerButton>
    </Popconfirm>);
  }
  else {
    return <div>{data.slotCode}</div>;
  }
}
function Index() {
  const [editQuantityData, setEditQuantityData] = useState<ViewStockSlot>();
  const columns = useMemo(() => getColumns(setEditQuantityData), []);
  const searchProps = useRef<StockSlotSplitPageProps>({ current: 1, pageSize: 13 });
  const [data, setData] = useState<PaginationData<ViewStockSlot>>({ items: [], current: searchProps.current.current, pageSize: searchProps.current.pageSize, total: 1 });
  const [loading, setLoading] = useState(false);
  const [ids, setIds] = useState<string>("");
  const [editCheckInventoryData, setEditCheckInventoryData] = useState<ViewCheckInventory[]>();
 
  const query = useCallback((current: number, pageSize: number) => {
    setLoading(true);
    searchProps.current.current = current;
    searchProps.current.pageSize = pageSize;
    getViews(searchProps.current)
      .then(s => {
        console.log(s);
        setData(s);
      }
      )
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const onSearch = useCallback(
    (data: {}) => {
      var _data = data as any;
      if (_data && _data?.warehouseIds) {
        _data.warehouseIds = _data?.warehouseIds.toString();
      }
      searchProps.current = { ...searchProps.current, ..._data, current: 1 };
      query(searchProps.current.current, searchProps.current.pageSize);
    },
    [query]
  );

  const _inventory = useCallback(() => {
    if (!ids) {
      message.error('请选择要操作的数据！'); return;
    }
    try {
      setLoading(true);
      inventory(ids).then(s => {
        if (s) {
          message.error(s);
        } else {
          message.success('操作成功！');
        }
      });
    } catch (error) {

      message.info(JSON.stringify(error));
    }
    finally {
      setLoading(false);
    }
  }, [ids]);
  useEffect(() => {
    onSearch({});
  }, [onSearch]);
  const [selectionType] = useState<"checkbox" | "radio">("checkbox");
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: {}[]) => {
      setIds(selectedRowKeys.toString());
      //  console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record: {}) => {
      console.log("getCheckboxProps", record)
      const tmp = record as any;
      return {
        disabled: tmp.isCheck === false,
      };
    }
  };
  const pageChange = useQueryPageChange(searchProps, query);
  const onDownloadTemplate = useCallback(() => {
    window.open(
      "http://" +
      window.location.hostname +
      ":" +
      window.location.port +
      "/ExportExcel/科德盘点导入(模板和示例).xlsx"
    );
  }, []);
  const props: UploadProps = {
    name: "file",
    action: "/api/StockSlot/GetCheckInventory",
    headers: {
      authorization: axios.defaults.headers.common["Authorization"] ? axios.defaults.headers.common["Authorization"].toString() : '',
    },
    onChange(info) {
      console.log("info:" + JSON.stringify(info));
      if (info.file.status === "done") {

        if(info.file.response.length>0){
          setEditCheckInventoryData(info.file.response);
        }
        else{
          message.error('数据格式错误或无数据！');
        }
        // debugger
        // //  setMsg(info.file.response);
        // if (info.file.response != "成功导入：0条数据") {
        //   message.success(info.file.response);
        //   setTimeout(() => {
        //     // onQuery();
        //     //  setMsg('');
        //   }, 3000);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name}上传失败:${info.file.response}`);
      }
    },
  };
  return <Fragment>
    <SearchComponent onSearch={onSearch} />
    <CommonTable
      rowSelection={{
        type: selectionType,
        ...rowSelection,
      }}
      rowKey={(s) => s.id}
      heightOffset={80}
      loading={loading}
      columns={columns}
      dataSource={data.items}
      isPrintFooter={false}
      pagination={{
        total: data.total,
        pageSize: data.pageSize,
        current: data.current,
        onChange: pageChange,
        showSizeChanger: true,
      }}
    />
    {editQuantityData && <EditQuantityForm data={editQuantityData} onCancel={() => setEditQuantityData(undefined)} />}
    {editCheckInventoryData && <CheckInventory record={editCheckInventoryData} onCancel={() => setEditCheckInventoryData(undefined)} />}
    <div style={{ marginTop: -35, marginLeft: 150, float: "left" }}>
      <TableInnerButton type="link" onClick={() => { _inventory(); }} style={{ marginTop: -10 }}>盘点</TableInnerButton>
    </div>

    <div style={{ position: "relative" }}>
      <div
        style={{ position: "absolute", left: 200, top: -40, width: 400 }}
      >
        <Button type="link">库存导入：</Button>
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>导入Excel格式文件</Button>
        </Upload>
        <Button
          icon={<ArrowDownOutlined />}
          style={{ position: "absolute", left: 280, top: -0 }}
          onClick={onDownloadTemplate}
        >
          下载模板
        </Button>
      </div>  </div>
    <PrintFooter data={data.items} title="库存" columns={columns} />
  </Fragment>;
}
